import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
const operationTransferApi = factory.get("operationTransfer");
const initialState = {
  searchBody: {},
  operationTransfer: {
    loading: false,
    dialog: false,
    form: {
      id: null,
      balance: "",
      buying_price: "",
      cash_paid: "",
      supplier_id: null,
      sim_card_id: null,
      note: "",
    },
  },
  operationTransfers: {
    loading: false,
    data: [],
    total: 0,
  },
};

export const operationTransferSlice = createSlice({
  name: "operationTransfer",
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.operationTransfer.dialog = !state.operationTransfer.dialog;
    },
    setDataTable: (state, { payload }) => {
      state.operationTransfers.data = payload.data.data;
      state.operationTransfers.total = payload.data.total;
    },
    setById: (state, { payload }) => {
      state.operationTransfer.form = payload;
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    resetForm: (state, action) => {
      state.operationTransfer.form = initialState.operationTransfer.form;
    },
    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
  },
});

export const {
  setLoading,
  setDialog,
  setById,
  setDataTable,
  resetForm,
  setSearchBody,
} = operationTransferSlice.actions;

export default operationTransferSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("operationTransfer"));
    const res = await operationTransferApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading("operationTransfer"));
  } catch (err) {
    dispatch(setLoading("operationTransfer"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const deleteById = (id, _SearchBody) => async (dispatch) => {
  try {
    await operationTransferApi.delete(id);
    dispatch(
      showNotification({
        message: "تم الحذف بنجاح",
        type: "success",
      })
    );
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getById = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("operationTransfer"));
    await dispatch(setById(data));

    dispatch(setDialog());
    dispatch(setLoading("operationTransfer"));
  } catch (err) {
    dispatch(setLoading("operationTransfer"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const create = (data, _SearchBody) => async (dispatch) => {
  try {
    await operationTransferApi.create(data);
    dispatch(
      showNotification({
        message: "تمت الاضافة  بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
export const OperationTransfer = {
  getAll,
  deleteById,
  getById,
  create,
};
